export default "https://assets.egbcdn.net/assets/packs/_/images/beer/therese_von_bayern/beer-before-start-73326bf44ce0bf8d68b2706a3d4bdf60.png";